<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="AARq">
<div class="image1"><img alt="images/himg-6-1.jpg" src="images/himg-6-1.jpg"/></div>
<p class="noind" id="pz19-3"><b><span class="dcap">A</span></b> little bit of light impacts a lot of darkness. The inky blackness of a cave is not so ominous once you turn on a flashlight. Light also gives comfort throughout the night—the literal night as well as the metaphorical night. And light—the sun bursting through the rainclouds—brings hope and joy with each new day. </p>
<p id="pz19-5">This is why Jesus called for His followers to let their lights “shine before men.” Those who have named Jesus as Savior and Lord have the ability to shine this kind of comforting, joyful light to people in the world. Do you know that within you is a light burning with heaven’s fire? As a result, your faith should cause you to behave differently than the world. Your true faith in God should show through in your actions and reflect your heavenly Father. People should see God through you. </p>
<p id="pz19-6">When you walk with God, His Spirit shines your light before others so people see your good works and the love of God within you. God has given you the gift of light within you. May you use it for His glory. After all, a little bit of light dispels a lot of darkness. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter14.vue?6b6ed552